var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.732,
    height: 24.689,
    viewBox: "0 0 24.732 24.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkdin",
    transform: "translate(-8.842 -8.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M937.348,90.963h-5.121V82.944c0-1.912-.034-4.374-2.663-4.374-2.667,0-3.075,2.083-3.075,4.235v8.158h-5.121V74.471h4.916v2.254h.069a5.387,5.387,0,0,1,4.85-2.664c5.19,0,6.147,3.414,6.147,7.855ZM915.59,72.217a2.972,2.972,0,1,1,2.971-2.972,2.972,2.972,0,0,1-2.971,2.972m2.56,18.746h-5.126V74.471h5.126Z",
    transform: "translate(-903.776 -57.355)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked_in.7b5a363932b503cbe9dbdc60c491a259.svg";
export { ForwardRef as ReactComponent };